import { Directive, ElementRef, HostListener } from '@angular/core';
import { CurrencyCustomPipe } from '../pipes/currency-custom.pipe';


@Directive({
  selector: '[currencyPasteMaxLength]',
})
export class CurrencyPasteMaxLengthDirective {

  qtdMaximaCaracteres = 0;

  constructor(private readonly element: ElementRef,
    private currencyCustomPipe: CurrencyCustomPipe
    ) {
    if (element && element.nativeElement.maxLength) {
      this.qtdMaximaCaracteres = element.nativeElement.maxLength;
    }
  }

  @HostListener('paste', ['$event'])
  onKeyPress(event: ClipboardEvent) {
    event.preventDefault();
    const elemento = event.target as HTMLTextAreaElement;
    let valor: string = event.clipboardData.getData("text");

    valor = valor.replace(/\D/g, '');

    if (valor.length >= 3) {
      valor = valor.substring(0, valor.length - 2) + "." + valor.substring(valor.length - 2, valor.length);
    } else {
      valor = "0." + valor;
    }

    let valorFormatado =  this.currencyCustomPipe.transform(valor, "R$");

    let qtdRemover = valorFormatado.length - this.qtdMaximaCaracteres;

    if (qtdRemover > 0) {
      valorFormatado = valorFormatado.substring(qtdRemover + 3, valorFormatado.length);
    }

    valorFormatado = valorFormatado.substring(0, this.qtdMaximaCaracteres);
    valorFormatado = valorFormatado.replace('R$', '');
    elemento.value = valorFormatado;
  }

}
